module.exports = __webpack_public_path__ + "img/tx001.d0289dc0.png";